import { createContext, useContext, useState, useEffect } from "react";

const translations = {
  tr: {
    // Header
    home: "Ana Sayfa",
    search: "Haber Ara...",
    searchAI: "AI ile anlam bazlı ara...",
    normalSearch: "Normal Arama",
    aiSearch: "AI Semantik Arama",
    searching: "Aranıyor...",
    aiAnalyzing: "AI analiz ediyor...",
    noResults: "Sonuç bulunamadı",
    breakingNews: "Son Dakika",
    trend: "TREND",
    install: "Yükle",
    login: "Giriş",
    leaderboard: "Liderlik",
    // Categories
    gundem: "Gündem", ekonomi: "Ekonomi", spor: "Spor", teknoloji: "Teknoloji",
    kultur: "Kültür", saglik: "Sağlık", dunya: "Dünya", bilim: "Bilim",
    // News
    views: "görüntülenme", news: "haber", readMore: "Devamını Oku",
    relatedNews: "İlgili Haberler", shareNews: "Bu haberi paylaş",
    copyLink: "Linki Kopyala", linkCopied: "Link kopyalandı!",
    sentToTelegram: "Telegram'a gönderildi",
    // AI
    aiTitle: "Loft.press AI", aiSubtitle: "Haber Asistanı",
    aiWelcome: "Güncel haberler hakkında sorularınızı sorun, yapay zeka size yanıt versin.",
    aiPlaceholder: "Haberler hakkında bir soru sorun...",
    aiAskMore: "Bir soru daha sorun...",
    aiNewChat: "Yeni Sohbet", aiSources: "Kaynaklar",
    aiDisclaimer: "Loft.press AI haberlere dayalı yanıtlar üretir. Doğruluğu garanti edilmez.",
    aiPositive: "Pozitif", aiNegative: "Negatif", aiNeutral: "Nötr",
    aiSummary: "AI Özet", people: "Kişiler", companies: "Şirketler", entities: "Varlıklar",
    suggestedQ: ["Bugün gündemde neler var?", "Ekonomide son durum nedir?", "Sporda neler oluyor?", "Teknoloji dünyasından haberler", "Dünyada en çok konuşulan konular"],
    // Market
    gold: "Altın",
    // Footer
    footerDesc: "Gerçeğin izinde, haberden öte. Doğru, tarafsız ve insanca haber anlayışıyla 7/24 sizinle.",
    categories_title: "Kategoriler", corporate: "Kurumsal",
    followUs: "Bizi Takip Edin",
    newsletterTitle: "Gündemi Yakalayın",
    newsletterDesc: "En güncel haberleri her gün e-posta kutunuza gönderelim.",
    emailPlaceholder: "E-posta adresiniz",
    subscribe: "Abone Ol", subscribed: "Abone Olundu!",
    copyright: "Tüm hakları saklıdır.",
    footerSlogan: "Doğru haber, insanca anlatım",
    location: "İstanbul, Türkiye", alwaysOn: "7/24 Kesintisiz Yayın",
    // Pages
    about: "Hakkımızda", contact: "İletişim", masthead: "Künye",
    // Trending
    worldTrends: "Dünyada Gündem", aiTrend: "AI Trend",
    articles: "haber",
    mostRead: "En Çok Okunanlar",
    popularThisWeek: "Bu haftanın popüler haberleri",
    noPopularNews: "Henüz popüler haber yok",
    // Breadcrumb
    homePage: "Ana Sayfa",
    // Common
    loading: "Yükleniyor...", error: "Hata", allNews: "Tüm Haberler",
    latestNews: "Son Haberler",
    // Unsubscribe
    unsubscribed: "Abonelik İptal Edildi",
    unsubscribedDesc: "Artık haber bülteni almayacaksınız.",
    backToHome: "Ana Sayfaya Dön",
    invalidLink: "Geçersiz abonelik iptali bağlantısı.",
    unsubscribing: "Abonelik iptal ediliyor...",
  },
  en: {
    home: "Home", search: "Search News...", searchAI: "AI semantic search...",
    normalSearch: "Normal Search", aiSearch: "AI Semantic Search",
    searching: "Searching...", aiAnalyzing: "AI analyzing...",
    noResults: "No results found", breakingNews: "Breaking News",
    trend: "TREND", install: "Install",
    login: "Login", leaderboard: "Leaderboard",
    gundem: "Agenda", ekonomi: "Economy", spor: "Sports", teknoloji: "Technology",
    kultur: "Culture", saglik: "Health", dunya: "World", bilim: "Science",
    views: "views", news: "news", readMore: "Read More",
    relatedNews: "Related News", shareNews: "Share this news",
    copyLink: "Copy Link", linkCopied: "Link copied!",
    sentToTelegram: "Sent to Telegram",
    aiTitle: "Loft.press AI", aiSubtitle: "News Assistant",
    aiWelcome: "Ask questions about current news, AI will answer you.",
    aiPlaceholder: "Ask a question about news...",
    aiAskMore: "Ask another question...",
    aiNewChat: "New Chat", aiSources: "Sources",
    aiDisclaimer: "Loft.press AI generates responses based on news. Accuracy is not guaranteed.",
    aiPositive: "Positive", aiNegative: "Negative", aiNeutral: "Neutral",
    aiSummary: "AI Summary", people: "People", companies: "Companies", entities: "Entities",
    suggestedQ: ["What's in the news today?", "How's the economy?", "What's happening in sports?", "Technology news", "Most discussed topics worldwide"],
    gold: "Gold",
    footerDesc: "In pursuit of truth, beyond news. With accurate, impartial and humane journalism 24/7.",
    categories_title: "Categories", corporate: "Corporate",
    followUs: "Follow Us",
    newsletterTitle: "Stay Updated",
    newsletterDesc: "Get the latest news delivered to your inbox every day.",
    emailPlaceholder: "Your email address",
    subscribe: "Subscribe", subscribed: "Subscribed!",
    copyright: "All rights reserved.",
    footerSlogan: "Accurate news, humane storytelling",
    location: "Istanbul, Turkey", alwaysOn: "24/7 Non-stop Broadcasting",
    about: "About Us", contact: "Contact", masthead: "Masthead",
    worldTrends: "World Trends", aiTrend: "AI Trend",
    articles: "articles", homePage: "Home",
    mostRead: "Most Read",
    popularThisWeek: "Popular news this week",
    noPopularNews: "No popular news yet",
    loading: "Loading...", error: "Error", allNews: "All News",
    latestNews: "Latest News",
    unsubscribed: "Unsubscribed",
    unsubscribedDesc: "You will no longer receive newsletters.",
    backToHome: "Back to Home",
    invalidLink: "Invalid unsubscribe link.",
    unsubscribing: "Unsubscribing...",
  },
  ar: {
    home: "الرئيسية", search: "ابحث في الأخبار...", searchAI: "بحث دلالي بالذكاء الاصطناعي...",
    normalSearch: "بحث عادي", aiSearch: "بحث ذكي",
    searching: "جاري البحث...", aiAnalyzing: "الذكاء الاصطناعي يحلل...",
    noResults: "لم يتم العثور على نتائج", breakingNews: "عاجل",
    trend: "رائج", install: "تثبيت",
    login: "دخول", leaderboard: "المتصدرين",
    gundem: "أجندة", ekonomi: "اقتصاد", spor: "رياضة", teknoloji: "تكنولوجيا",
    kultur: "ثقافة", saglik: "صحة", dunya: "عالم", bilim: "علوم",
    views: "مشاهدة", news: "خبر", readMore: "اقرأ المزيد",
    relatedNews: "أخبار ذات صلة", shareNews: "شارك هذا الخبر",
    copyLink: "نسخ الرابط", linkCopied: "تم نسخ الرابط!",
    sentToTelegram: "تم الإرسال إلى تيليغرام",
    aiTitle: "Loft.press AI", aiSubtitle: "مساعد الأخبار",
    aiWelcome: "اسأل أسئلة حول الأخبار الحالية، سيجيبك الذكاء الاصطناعي.",
    aiPlaceholder: "اسأل سؤالاً عن الأخبار...",
    aiAskMore: "اسأل سؤالاً آخر...",
    aiNewChat: "محادثة جديدة", aiSources: "المصادر",
    aiDisclaimer: "ينتج الذكاء الاصطناعي إجابات بناءً على الأخبار. الدقة غير مضمونة.",
    aiPositive: "إيجابي", aiNegative: "سلبي", aiNeutral: "محايد",
    aiSummary: "ملخص ذكي", people: "أشخاص", companies: "شركات", entities: "كيانات",
    suggestedQ: ["ما الجديد اليوم؟", "كيف حال الاقتصاد؟", "أخبار الرياضة", "أخبار التكنولوجيا", "أكثر المواضيع نقاشاً في العالم"],
    gold: "ذهب",
    footerDesc: "في سعينا للحقيقة، أبعد من الأخبار. صحافة دقيقة ومحايدة وإنسانية على مدار الساعة.",
    categories_title: "الأقسام", corporate: "الشركة",
    followUs: "تابعنا",
    newsletterTitle: "ابق على اطلاع",
    newsletterDesc: "احصل على آخر الأخبار في بريدك الإلكتروني يومياً.",
    emailPlaceholder: "بريدك الإلكتروني",
    subscribe: "اشترك", subscribed: "تم الاشتراك!",
    copyright: "جميع الحقوق محفوظة.",
    footerSlogan: "أخبار دقيقة، سرد إنساني",
    location: "إسطنبول، تركيا", alwaysOn: "بث متواصل ٢٤/٧",
    about: "من نحن", contact: "اتصل بنا", masthead: "البطاقة",
    worldTrends: "الأحداث العالمية", aiTrend: "رائج ذكي",
    articles: "مقال", homePage: "الرئيسية",
    mostRead: "الأكثر قراءة",
    popularThisWeek: "أخبار الأسبوع الشائعة",
    noPopularNews: "لا توجد أخبار شائعة بعد",
    loading: "جاري التحميل...", error: "خطأ", allNews: "جميع الأخبار",
    latestNews: "آخر الأخبار",
    unsubscribed: "تم إلغاء الاشتراك",
    unsubscribedDesc: "لن تتلقى المزيد من النشرات الإخبارية.",
    backToHome: "العودة للرئيسية",
    invalidLink: "رابط إلغاء اشتراك غير صالح.",
    unsubscribing: "جاري إلغاء الاشتراك...",
  },
  ru: {
    home: "Главная", search: "Поиск новостей...", searchAI: "Семантический поиск ИИ...",
    normalSearch: "Обычный поиск", aiSearch: "ИИ Семантический поиск",
    searching: "Поиск...", aiAnalyzing: "ИИ анализирует...",
    noResults: "Ничего не найдено", breakingNews: "Срочно",
    trend: "ТРЕНД", install: "Установить",
    login: "Вход", leaderboard: "Лидеры",
    gundem: "Повестка", ekonomi: "Экономика", spor: "Спорт", teknoloji: "Технологии",
    kultur: "Культура", saglik: "Здоровье", dunya: "Мир", bilim: "Наука",
    views: "просмотров", news: "новостей", readMore: "Читать далее",
    relatedNews: "Похожие новости", shareNews: "Поделиться новостью",
    copyLink: "Скопировать ссылку", linkCopied: "Ссылка скопирована!",
    sentToTelegram: "Отправлено в Telegram",
    aiTitle: "Loft.press AI", aiSubtitle: "Новостной ассистент",
    aiWelcome: "Задавайте вопросы о текущих новостях, ИИ ответит вам.",
    aiPlaceholder: "Задайте вопрос о новостях...",
    aiAskMore: "Задайте ещё вопрос...",
    aiNewChat: "Новый чат", aiSources: "Источники",
    aiDisclaimer: "Loft.press AI генерирует ответы на основе новостей. Точность не гарантирована.",
    aiPositive: "Позитивный", aiNegative: "Негативный", aiNeutral: "Нейтральный",
    aiSummary: "ИИ Резюме", people: "Люди", companies: "Компании", entities: "Объекты",
    suggestedQ: ["Что нового сегодня?", "Как дела в экономике?", "Новости спорта", "Новости технологий", "Самые обсуждаемые темы в мире"],
    gold: "Золото",
    footerDesc: "В поисках правды, за пределами новостей. Точная, беспристрастная и гуманная журналистика 24/7.",
    categories_title: "Категории", corporate: "Компания",
    followUs: "Подписывайтесь",
    newsletterTitle: "Будьте в курсе",
    newsletterDesc: "Получайте последние новости на вашу почту каждый день.",
    emailPlaceholder: "Ваш email",
    subscribe: "Подписаться", subscribed: "Подписано!",
    copyright: "Все права защищены.",
    footerSlogan: "Точные новости, человечное повествование",
    location: "Стамбул, Турция", alwaysOn: "Круглосуточное вещание",
    about: "О нас", contact: "Контакты", masthead: "Выходные данные",
    worldTrends: "Мировые тренды", aiTrend: "ИИ Тренд",
    articles: "статей", homePage: "Главная",
    mostRead: "Самое читаемое",
    popularThisWeek: "Популярные новости за неделю",
    noPopularNews: "Пока нет популярных новостей",
    loading: "Загрузка...", error: "Ошибка", allNews: "Все новости",
    latestNews: "Последние новости",
    unsubscribed: "Подписка отменена",
    unsubscribedDesc: "Вы больше не будете получать рассылку.",
    backToHome: "На главную",
    invalidLink: "Недействительная ссылка для отмены подписки.",
    unsubscribing: "Отмена подписки...",
  }
};

const LANGS = [
  { code: "tr", label: "TR", flag: "🇹🇷" },
  { code: "en", label: "EN", flag: "🇬🇧" },
  { code: "ar", label: "AR", flag: "🇸🇦" },
  { code: "ru", label: "RU", flag: "🇷🇺" },
];

const LangContext = createContext();

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("loft_lang") || "tr");

  useEffect(() => {
    localStorage.setItem("loft_lang", lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);

  const t = (key) => translations[lang]?.[key] || translations.tr[key] || key;

  return (
    <LangContext.Provider value={{ lang, setLang, t, LANGS }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
